import DashboardIcon from '@atlaskit/icon/core/dashboard';
import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';
import { useIntl } from 'react-intl-next';
import { useRouter } from 'react-resource-router';

import { boysenberryDashboardPath } from '../../../../routes/paths';
import { useAnalyticsWebClient } from '../../../../utils/analytics/context';

import messages from './messages';

export const DashboardButton = () => {
	const analyticsWebClient = useAnalyticsWebClient();
	const [{ route }] = useRouter();
	const { formatMessage } = useIntl();

	return (
		<LinkMenuItem
			elemBefore={<DashboardIcon label="" />}
			href={boysenberryDashboardPath}
			isSelected={route.path === boysenberryDashboardPath}
			onClick={() => {
				analyticsWebClient.sendUIEvent({
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: 'boysenberry-dashboard-button',
					source: 'boysenberry-sidebar',
				});
			}}
		>
			{formatMessage(messages.dashboardButtonLabel)}
		</LinkMenuItem>
	);
};
